import { Button, Callout } from "@blueprintjs/core"
import React from "react"
import CustomTagInput from "components/Atoms/CustomTagInput"
import StaticSelector from "components/Atoms/StaticSelector"
import StringInput from "components/Atoms/StringInput"
export const infoType = [
  { id: "NUMB", name: "Number" },
  { id: "DROP", name: "Dropdown" },
  { id: "TEXT", name: "Text" },
  { id: "BOOL", name: "Boolean" },
]
const ParameterValues = ({ param, path, onRemove, disabled }) => {
  const paramIndex = param.uuid
  return (
    <Callout
      className="vt-parameters py-4 px-3"
      style={{ background: "#F5F7FB" }}
    >
      <div className="grid grid-cols-12 gap-4">
        <div className="ml-3 col-span-3">
          <StringInput
            autoFocus={true}
            path={`${path}.${paramIndex}.name`}
            label="Parameter Name"
          ></StringInput>
        </div>
        <div className="col-span-3">
          <StringInput
            label="Standards"
            path={`${path}.${paramIndex}.standard`}
          ></StringInput>
        </div>
        <div className="col-span-3">
          <StaticSelector
            big={true}
            label="Information As"
            items={infoType}
            valueAs="string"
            path={`${path}.${paramIndex}.valueType`}
          ></StaticSelector>
        </div>
        <div className="col-span-1 self-center">
          <Button
            disabled={disabled}
            tabIndex={-1}
            minimal={true}
            icon="minus"
            intent="danger"
            onClick={e => onRemove(path, paramIndex)}
          ></Button>
        </div>
      </div>
      {param.valueType?.id === "DROP" && (
        <div className="grid grid-cols-12 gap-4 mt-2">
          <div className="ml-3 col-span-6">
            <CustomTagInput
              label="Options"
              path={`${path}.${paramIndex}.dropdownValues`}
            ></CustomTagInput>
          </div>
        </div>
      )}
    </Callout>
  )
}

export default ParameterValues
